import { defineStore } from 'pinia';
import apiClient from '@/services/authService';

export const useClinicStore = defineStore('clinic', {
  state: () => {
          const defaultState = {
        clinic: {
          nome: '',
          endereco: '',
          telefone: '',
          url_portal_paciente: '',
          cnes: '',
                  logo: '/styles/public/inovamed.png',
        login_logo: '/styles/public/logo_login.png',
        cor_botao: '#059669',
        cor_icone: '#059669',
        cor_fonte: '#22223b',
        cor_botao_dark: '#fd79ac',
        cor_icone_dark: '#fd79ac',
        cor_fonte_dark: '#fff',
        cor_secundaria: '#fd79ac',
        cor_secundaria_dark: '#fd79ac',
        cor_wave_login: '#fbd5e5',
        cor_wave_login_dark: '#4d5b6a',
        cor_wave_login_secundaria: '#e9b6c9',
        cor_wave_login_secundaria_dark: '#b48bbd',
        cor_gradiente_login_from: '#fbd5e5',
        cor_gradiente_login_via: '#fbd5e5',
        cor_gradiente_login_to: '#fbd5e5',
        cor_gradiente_login_radial: '#fbd5e5',
        cor_gradiente_login_from_dark: '#23272f',
        cor_gradiente_login_via_dark: '#fbd5e5',
        cor_gradiente_login_to_dark: '#fbd5e5',
        cor_gradiente_login_radial_dark: '#fbd5e5',
      },
      isLoaded: false,
    };

    // Tenta carregar do localStorage
    try {
      const saved = localStorage.getItem('clinicData');
      if (saved) {
        const data = JSON.parse(saved);
        return {
          clinic: { ...defaultState.clinic, ...data },
          isLoaded: true,
        };
      }
    } catch (error) {
      console.error('Erro ao carregar dados do localStorage:', error);
    }

    return defaultState;
  },

  actions: {
    // Carrega dados do localStorage ao inicializar
    loadFromStorage() {
      const saved = localStorage.getItem('clinicData');
      if (saved) {
        try {
          const data = JSON.parse(saved);
          this.clinic = { ...this.clinic, ...data };
          this.isLoaded = true;
          this.applyClinicStyles();
        } catch (error) {
          console.error('Erro ao carregar dados do localStorage:', error);
        }
      }
    },

    // Salva dados no localStorage
    saveToStorage() {
      localStorage.setItem('clinicData', JSON.stringify(this.clinic));
    },

    // Busca dados da API (apenas quando necessário)
    async fetchClinic() {
      try {
        const { data } = await apiClient.get('/api/v1/clinicsettings/styles/');
        this.clinic = { ...this.clinic, ...data };
        if (data.cor_wave_login) this.clinic.cor_wave_login = data.cor_wave_login;
        if (data.cor_wave_login_dark) this.clinic.cor_wave_login_dark = data.cor_wave_login_dark;
        if (data.login_logo) this.clinic.login_logo = data.login_logo;
        if (data.logo) this.clinic.logo = data.logo;
        if (data.cor_wave_login_secundaria) this.clinic.cor_wave_login_secundaria = data.cor_wave_login_secundaria;
        if (data.cor_wave_login_secundaria_dark) this.clinic.cor_wave_login_secundaria_dark = data.cor_wave_login_secundaria_dark;
        if (data.cor_gradiente_login_from) this.clinic.cor_gradiente_login_from = data.cor_gradiente_login_from;
        if (data.cor_gradiente_login_via) this.clinic.cor_gradiente_login_via = data.cor_gradiente_login_via;
        if (data.cor_gradiente_login_to) this.clinic.cor_gradiente_login_to = data.cor_gradiente_login_to;
        if (data.cor_gradiente_login_radial) this.clinic.cor_gradiente_login_radial = data.cor_gradiente_login_radial;
        if (data.cor_gradiente_login_from_dark) this.clinic.cor_gradiente_login_from_dark = data.cor_gradiente_login_from_dark;
        if (data.cor_gradiente_login_via_dark) this.clinic.cor_gradiente_login_via_dark = data.cor_gradiente_login_via_dark;
        if (data.cor_gradiente_login_to_dark) this.clinic.cor_gradiente_login_to_dark = data.cor_gradiente_login_to_dark;
        if (data.cor_gradiente_login_radial_dark) this.clinic.cor_gradiente_login_radial_dark = data.cor_gradiente_login_radial_dark;
        this.isLoaded = true;
        this.saveToStorage();
        this.applyClinicStyles();
        return data;
      } catch (error) {
        console.error('Erro ao buscar configurações da clínica:', error);
        throw error;
      }
    },

    // Busca dados completos da clínica (incluindo nome, endereço, etc.)
    async fetchClinicData() {
      try {
        const { data } = await apiClient.get('/api/v1/clinicsettings/');
        this.clinic = { ...this.clinic, ...data };
        this.isLoaded = true;
        this.saveToStorage();
        this.applyClinicStyles();
        return data;
      } catch (error) {
        console.error('Erro ao buscar dados completos da clínica:', error);
        throw error;
      }
    },

    // Atualiza as configurações
    async updateClinic(clinicData) {
      try {
        const { data } = await apiClient.put('/api/v1/clinicsettings/', clinicData);
        this.clinic = { ...this.clinic, ...data };
        if (data.cor_wave_login) this.clinic.cor_wave_login = data.cor_wave_login;
        if (data.cor_wave_login_dark) this.clinic.cor_wave_login_dark = data.cor_wave_login_dark;
        if (data.login_logo) this.clinic.login_logo = data.login_logo;
        if (data.logo) this.clinic.logo = data.logo;
        if (data.cor_wave_login_secundaria) this.clinic.cor_wave_login_secundaria = data.cor_wave_login_secundaria;
        if (data.cor_wave_login_secundaria_dark) this.clinic.cor_wave_login_secundaria_dark = data.cor_wave_login_secundaria_dark;
        if (data.cor_gradiente_login_from) this.clinic.cor_gradiente_login_from = data.cor_gradiente_login_from;
        if (data.cor_gradiente_login_via) this.clinic.cor_gradiente_login_via = data.cor_gradiente_login_via;
        if (data.cor_gradiente_login_to) this.clinic.cor_gradiente_login_to = data.cor_gradiente_login_to;
        if (data.cor_gradiente_login_radial) this.clinic.cor_gradiente_login_radial = data.cor_gradiente_login_radial;
        if (data.cor_gradiente_login_from_dark) this.clinic.cor_gradiente_login_from_dark = data.cor_gradiente_login_from_dark;
        if (data.cor_gradiente_login_via_dark) this.clinic.cor_gradiente_login_via_dark = data.cor_gradiente_login_via_dark;
        if (data.cor_gradiente_login_to_dark) this.clinic.cor_gradiente_login_to_dark = data.cor_gradiente_login_to_dark;
        if (data.cor_gradiente_login_radial_dark) this.clinic.cor_gradiente_login_radial_dark = data.cor_gradiente_login_radial_dark;
        this.saveToStorage();
        this.applyClinicStyles();
        return data;
      } catch (error) {
        console.error('Erro ao atualizar configurações da clínica:', error);
        throw error;
      }
    },

    // Aplica estilos CSS baseados nas cores da clínica
    applyClinicStyles() {
      const root = document.documentElement;
      const isDark = root.classList.contains('dark');
      
      // Aplica as cores baseadas no modo atual
      root.style.setProperty('--clinic-btn-bg', isDark ? 
        (this.clinic.cor_botao_dark || '#fd79ac') : 
        (this.clinic.cor_botao || '#059669')
      );
      
      root.style.setProperty('--clinic-btn-bg-hover', isDark ? 
        (this.clinic.cor_secundaria_dark || '#fd79ac') : 
        (this.clinic.cor_secundaria || '#fd79ac')
      );
      
      root.style.setProperty('--clinic-icon-color', isDark ? 
        (this.clinic.cor_icone_dark || '#fd79ac') : 
        (this.clinic.cor_icone || '#059669')
      );
      
      root.style.setProperty('--clinic-font-color', isDark ? 
        (this.clinic.cor_fonte_dark || '#fff') : 
        (this.clinic.cor_fonte || '#22223b')
      );
      
      // Força um reflow para garantir que as mudanças sejam aplicadas imediatamente
      root.offsetHeight;
    },

    // Inicializa o store (carrega do localStorage e aplica estilos)
    initialize() {
      this.loadFromStorage();
      this.applyClinicStyles(); // Sempre aplica os estilos, usando valores padrão se necessário
    },

    // Limpa os dados (útil para logout)
    clearData() {
      localStorage.removeItem('clinicData');
      this.clinic = {
        nome: '',
        endereco: '',
        telefone: '',
        url_portal_paciente: '',
        cnes: '',
        logo: '/styles/public/inovamed.png',
        login_logo: '/styles/public/logo_login.png',
        cor_botao: '#059669',
        cor_icone: '#059669',
        cor_fonte: '#22223b',
        cor_botao_dark: '#fd79ac',
        cor_icone_dark: '#fd79ac',
        cor_fonte_dark: '#fff',
        cor_secundaria: '#fd79ac',
        cor_secundaria_dark: '#fd79ac',
        cor_wave_login: '#fbd5e5',
        cor_wave_login_dark: '#4d5b6a',
        cor_wave_login_secundaria: '#e9b6c9',
        cor_wave_login_secundaria_dark: '#b48bbd',
        cor_gradiente_login_from: '#fbd5e5',
        cor_gradiente_login_via: '#fbd5e5',
        cor_gradiente_login_to: '#fbd5e5',
        cor_gradiente_login_radial: '#fbd5e5',
        cor_gradiente_login_from_dark: '#23272f',
        cor_gradiente_login_via_dark: '#fbd5e5',
        cor_gradiente_login_to_dark: '#fbd5e5',
        cor_gradiente_login_radial_dark: '#fbd5e5',
      };
      this.isLoaded = false;
    },

    // Busca apenas as cores da clínica (rota pública, para tela de login)
    async fetchClinicStyles() {
      try {
        const { data } = await apiClient.get('/api/v1/clinicsettings/styles/');
        // Atualiza apenas as cores no state
        this.clinic.login_logo = data.login_logo;
        this.clinic.cor_botao = data.cor_botao;
        this.clinic.cor_botao_dark = data.cor_botao_dark;
        this.clinic.cor_icone = data.cor_icone;
        this.clinic.cor_icone_dark = data.cor_icone_dark;
        this.clinic.cor_fonte = data.cor_fonte;
        this.clinic.cor_fonte_dark = data.cor_fonte_dark;
        this.clinic.cor_secundaria = data.cor_secundaria;
        this.clinic.cor_secundaria_dark = data.cor_secundaria_dark;
        this.clinic.cor_wave_login = data.cor_wave_login;
        this.clinic.cor_wave_login_dark = data.cor_wave_login_dark;
        this.clinic.cor_wave_login_secundaria = data.cor_wave_login_secundaria;
        this.clinic.cor_wave_login_secundaria_dark = data.cor_wave_login_secundaria_dark;
        this.clinic.cor_gradiente_login_from = data.cor_gradiente_login_from;
        this.clinic.cor_gradiente_login_via = data.cor_gradiente_login_via;
        this.clinic.cor_gradiente_login_to = data.cor_gradiente_login_to;
        this.clinic.cor_gradiente_login_radial = data.cor_gradiente_login_radial;
        this.clinic.cor_gradiente_login_from_dark = data.cor_gradiente_login_from_dark;
        this.clinic.cor_gradiente_login_via_dark = data.cor_gradiente_login_via_dark;
        this.clinic.cor_gradiente_login_to_dark = data.cor_gradiente_login_to_dark;
        this.clinic.cor_gradiente_login_radial_dark = data.cor_gradiente_login_radial_dark;
        this.applyClinicStyles();
      } catch (error) {
        console.error('Erro ao buscar estilos da clínica:', error);
      }
    },
  },

  getters: {
    hasData: (state) => state.isLoaded && state.clinic.nome !== '',
  }
}); 